module.exports = __webpack_public_path__ + "img/arrow_down.c3d75740.svg";